import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoImg from "../../assets/svg/Logo";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0", flexWrap: "wrap" }}>
            <Link className="flexCenter animate pointer" to="home" smooth={true} offset={-80}>
              <LogoImg />
            </Link>

            {/* ✅ Contact Info */}
            <InfoBlock className="whiteColor font13">
              <p>P. O. Box 172, Lumbadzi, Lilongwe</p>
              <p>
                Phone: <a href="tel:+265888855196" className="whiteColor">+265 888 855 196</a>
              </p>
              <p>
                Email: <a href="mailto:info@vascomw.org" className="whiteColor">info@vascomw.org</a>
              </p>
            </InfoBlock>

            <Link className="whiteColor animate pointer font13" to="home" smooth={true} offset={-80}>
              Back to top
            </Link>
          </InnerWrapper>

          {/* ✅ Production credit moved to the bottom */}
          <BottomNote className="whiteColor font13" style={{ textAlign: "center", padding: "10px 0" }}>
            © {getCurrentYear()} - Production by{" "}
            <a href="https://imperialsystemsmw.com" target="_blank" rel="noopener noreferrer" className="purpleColor font13">Imperial Systems</a>{" "}
            &{" "}
            <a href="https://www.beleae.com" target="_blank" rel="noopener noreferrer" className="purpleColor font13">Belea Enterprise</a>
          </BottomNote>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const StyleP = styled.p`
  text-align: center;
`;

const InfoBlock = styled.div`
  text-align: center;
  line-height: 1.6;

  a {
    text-decoration: none;
    color: inherit;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const BottomNote = styled.div`
  a {
    text-decoration: none;
    color: inherit;
  }

  @media (max-width: 768px) {
    padding-top: 10px;
  }
`;
